import PropTypes from "prop-types";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNewFilterdProducts } from "../../store/actions/product-actions";
import { SET_FILTER } from "../../store/types";

const NavMenuNew = ({ menuWhiteClass, sidebarMenu }) => {
  const { t } = useTranslation();

  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => setIsHovering(true);
  const handleMouseLeave = () => setIsHovering(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState("");

  useEffect(() => {
    setSelected(location.pathname);
  }, [location.pathname]);


  const handleChange = (e) => {
    const value = e.target.value;
    if (value !== location.pathname) {
      navigate(value);
    }
  };
  const brands = useSelector((state) => state.brands.list || []);
  // Divide the brands
  const getBrandUrl = (id) => {
    return `/shop-grid-standard?page=1&limit=15&usedType=USED&status=1&isVisible=1&brands=${id}&category=&color=&ram=&storage=`;


  };
  const renderBrandDiv = (brandList) => (
    <div
      style={{
        width: "35%",
        padding: "32px 28px",
        backgroundColor: "#ffffff",
        borderLeft: "1px solid rgba(0, 0, 0, 0.05)",
        borderRight: "1px solid rgba(0, 0, 0, 0.05)",
      }}
    >
      <h3
        style={{
          color: "#1a202c",
          fontSize: "18px",
          fontWeight: "700",
          marginBottom: "24px",
          fontFamily: "'Inter', -apple-system, sans-serif",
          letterSpacing: "-0.025em",
        }}
      >
        Popular Brands
      </h3>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "8px",
          fontFamily: "'Inter', -apple-system, sans-serif",
        }}
      >
        {brandList.map((brand) => (
          <a
            key={brand._id}
            href={getBrandUrl(brand._id)}
            style={{
              textDecoration: "none",
              color: "#4a5568",
              borderRadius: "8px",
              padding: "10px 8px",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              fontSize: "12px",
              fontWeight: "500",
              backgroundColor: "#f8fafc",
              border: "1px solid gray",
              textAlign: "center",
              position: "relative",
              overflow: "hidden",
              minHeight: "40px",
              height: "40px", // Force equal height
              minWidth: "90px", // Force consistent width
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: "1.2",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#667eea";
              e.currentTarget.style.color = "#ffffff";
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 10px 25px -5px rgba(102, 126, 234, 0.4)";
              e.currentTarget.style.borderColor = "#667eea";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#f8fafc";
              e.currentTarget.style.color = "#4a5568";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.borderColor = "black";
            }}
          >
            {brand.name}
          </a>
        ))}
      </div>
    </div>
  );


  const handleRedirect = (type) => {
    let baseUrl = "/shop-grid-standard?page=1&limit=15&status=1&isVisible=1";
    let finalUrl = "";
    const topBrandId = "672e21c31efe3942a7253872,67330217b90dba16f2694738"
    switch (type) {
      case "TOP_BRANDS":
        finalUrl = `${baseUrl}&usedType=USED&brands=${topBrandId}&category=&color=&ram=&storage=`;

        break;
      case "NEW_ARRIVALS":
        finalUrl = `/shop-grid-standard?NEW`;
        break;
      case "BEST_SELLERS":
        finalUrl = `${baseUrl}&isBestSeller=true&category=&color=&ram=&storage=`;
        break;
      case "REFURBISHED":
        finalUrl = `/shop-grid-standard?REFURBISHED `;
        break;
      default:
        return;
    }

    navigate(finalUrl);
  };

  const categoryImages = {
    TOP_BRANDS: "/assets/img/category/1.png",
    NEW_ARRIVALS: "/assets/img/category/5.png",
    BEST_SELLERS: "/assets/img/category/4.png",
    REFURBISHED: "/assets/img/category/3.png",
  };
  const [hoveredCategory, setHoveredCategory] = useState("TOP_BRANDS");
  const [imageOpacity, setImageOpacity] = useState(1);
  const handleMouseenter = (category) => {
    if (category !== hoveredCategory) {
      // Start fade out
      setImageOpacity(0);
      setTimeout(() => {
        setHoveredCategory(category);
        setImageOpacity(1); // Fade in new image
      }, 150); // Timing must match CSS transition duration
    }
  };
  const dispatch = useDispatch()
  const handleClearFilters = () => {

    const defaultFilters = {
      page: 1,
      limit: 15,
      color: [],
      // brandId: '',
      brands: [],
      modelId: [],
      category: [],
      storage: [],
      ram: [],
      discount: "",
      minPrice: "",
      maxPrice: "",
      sortOrder: "",
      sortBy: ""
    };

    Object.entries(defaultFilters).forEach(([filterType, value]) => {
      dispatch({
        type: SET_FILTER,
        payload: { filterType, value },
      });
    });

    localStorage.setItem("sortBy", "")
    localStorage.setItem("sortOrder", "")
  };
  return (
    <div
      className={clsx(
        sidebarMenu
          ? "sidebar-menu"
          : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
      )}
      style={{ backgroundColor: "#1C4598", width: "100%" }}
    >
      <nav>
        <ul>
          <li style={{ padding: "0 20px" }}>
            <Link
              to={process.env.PUBLIC_URL + "/"}
              style={{ color: "#fff", lineHeight: "0px" }}
            >
              {t("HOME")}
              {/* {sidebarMenu ? (
                <span>
                  <i className="fa fa-angle-right"></i>
                </span>
              ) : (
                <i className="fa fa-angle-down" />
              )} */}
            </Link>
            {/* <ul className="mega-menu mega-menu-padding">
              <li>
                <ul>
                  <li className="mega-menu-title">
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      {t("home_group_one")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-fashion"}>
                      {t("home_fashion")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-fashion-two"}>
                      {t("home_fashion_two")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-fashion-three"}>
                      {t("home_fashion_three")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-fashion-four"}>
                      {t("home_fashion_four")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-fashion-five"}>
                      {t("home_fashion_five")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-fashion-six"}>
                      {t("home_fashion_six")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-fashion-seven"}>
                      {t("home_fashion_seven")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-fashion-eight"}>
                      {t("home_fashion_eight")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-kids-fashion"}>
                      {t("home_kids_fashion")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-cosmetics"}>
                      {t("home_cosmetics")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-furniture"}>
                      {t("home_furniture")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-furniture-two"}>
                      {t("home_furniture_two")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-furniture-three"}>
                      {t("home_furniture_three")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-furniture-four"}>
                      {t("home_furniture_four")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="mega-menu-title">
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      {t("home_group_two")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-furniture-five"}>
                      {t("home_furniture_five")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-furniture-six"}>
                      {t("home_furniture_six")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-furniture-seven"}>
                      {t("home_furniture_seven")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-electronics"}>
                      {t("home_electronics")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-electronics-two"}>
                      {t("home_electronics_two")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={process.env.PUBLIC_URL + "/home-electronics-three"}
                    >
                      {t("home_electronics_three")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-book-store"}>
                      {t("home_book_store")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-book-store-two"}>
                      {t("home_book_store_two")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-plants"}>
                      {t("home_plants")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-flower-shop"}>
                      {t("home_flower_shop")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-flower-shop-two"}>
                      {t("home_flower_shop_two")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-organic-food"}>
                      {t("home_organic_food")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={process.env.PUBLIC_URL + "/home-organic-food-two"}
                    >
                      {t("home_organic_food_two")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-onepage-scroll"}>
                      {t("home_onepage_scroll")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="mega-menu-title">
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      {t("home_group_three")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-grid-banner"}>
                      {t("home_grid_banner")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-auto-parts"}>
                      {t("home_auto_parts")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-cake-shop"}>
                      {t("home_cake_shop")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-handmade"}>
                      {t("home_handmade")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-pet-food"}>
                      {t("home_pet_food")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={process.env.PUBLIC_URL + "/home-medical-equipment"}
                    >
                      {t("home_medical_equipment")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-christmas"}>
                      {t("home_christmas")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-black-friday"}>
                      {t("home_black_friday")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={process.env.PUBLIC_URL + "/home-black-friday-two"}
                    >
                      {t("home_black_friday_two")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/home-valentines-day"}>
                      {t("home_valentines_day")}
                    </Link>
                  </li>
                </ul>
              </li>
            </ul> */}
          </li>
          <li
            className="shopnav"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ padding: "10px 20px" }}
          >
            <Link
              to={process.env.PUBLIC_URL + "/shop-grid-standard?USED"}
              style={{
                color: "#fff",
                lineHeight: "0px",
                display: "inline-block",
              }}
              onClick={() => handleClearFilters()}
            >
              {" "}
              {t("SHOP")}
              <img
                src="\assets\img\svg\arrow.svg"
                style={{ marginLeft: "2px" }}
              ></img>
              {/* {sidebarMenu ? (
                <span>
                  <i className="fa fa-angle-right"></i>
                </span>
              ) : (
                <i className="fa fa-angle-down" />
              )} */}
            </Link>
            {/* <ul className="mega-menu">
              <li>
                <ul>
                  <li className="mega-menu-title">
                    <Link to={process.env.PUBLIC_URL + "/shop-grid-standard"}>
                      {t("shop_layout")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/shop-grid-standard"}>
                      {t("shop_grid_standard")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/shop-grid-filter"}>
                      {t("shop_grid_filter")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/shop-grid-two-column"}>
                      {t("shop_grid_two_column")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/shop-grid-no-sidebar"}>
                      {t("shop_grid_no_sidebar")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/shop-grid-full-width"}>
                      {t("shop_grid_full_width")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={process.env.PUBLIC_URL + "/shop-grid-right-sidebar"}
                    >
                      {t("shop_grid_right_sidebar")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/shop-list-standard"}>
                      {t("shop_list_standard")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/shop-list-full-width"}>
                      {t("shop_list_full_width")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/shop-list-two-column"}>
                      {t("shop_list_two_column")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="mega-menu-title">
                    <Link to={process.env.PUBLIC_URL + "/product/1"}>
                      {t("product_details")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/product/1"}>
                      {t("product_tab_bottom")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/product-tab-left/1"}>
                      {t("product_tab_left")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/product-tab-right/1"}>
                      {t("product_tab_right")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/product-sticky/1"}>
                      {t("product_sticky")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/product-slider/1"}>
                      {t("product_slider")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={process.env.PUBLIC_URL + "/product-fixed-image/1"}
                    >
                      {t("product_fixed_image")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/product/8"}>
                      {t("product_simple")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/product/1"}>
                      {t("product_variation")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/product/9"}>
                      {t("product_affiliate")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="mega-menu-img">
                    <Link to={process.env.PUBLIC_URL + "/shop-grid-standard"}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/img/banner/banner-12.png"
                        }
                        alt=""
                      />
                    </Link>
                  </li>
                </ul>
              </li>
            </ul> */}
          </li>
          {/* <li>
            <Link to={process.env.PUBLIC_URL + "/shop-grid-standard"}>
              {t("collection")}
            </Link>
          </li> */}
          {/* <li>
            <Link to={process.env.PUBLIC_URL + "/"}>
              {t("pages")}
              {sidebarMenu ? (
                <span>
                  <i className="fa fa-angle-right"></i>
                </span>
              ) : (
                <i className="fa fa-angle-down" />
              )}
            </Link>
            <ul className="submenu">
              <li>
                <Link to={process.env.PUBLIC_URL + "/cart"}>
                  {t("cart")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/checkout"}>
                  {t("checkout")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/wishlist"}>
                  {t("wishlist")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/compare"}>
                  {t("compare")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/my-account"}>
                  {t("my_account")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/login-register"}>
                  {t("login_register")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/about"}>
                  {t("about_us")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/contact"}>
                  {t("contact_us")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/not-found"}>
                  {t("404_page")}
                </Link>
              </li>
            </ul>
          </li> */}
          {/* <li>
            <Link to={process.env.PUBLIC_URL + "/blog-standard"}>
              {t("blog")}
              {sidebarMenu ? (
                <span>
                  <i className="fa fa-angle-right"></i>
                </span>
              ) : (
                <i className="fa fa-angle-down" />
              )}
            </Link>
            <ul className="submenu">
              <li>
                <Link to={process.env.PUBLIC_URL + "/blog-standard"}>
                  {t("blog_standard")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/blog-no-sidebar"}>
                  {t("blog_no_sidebar")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/blog-right-sidebar"}>
                  {t("blog_right_sidebar")}
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/blog-details-standard"}>
                  {t("blog_details_standard")}
                </Link>
              </li>
            </ul>
          </li> */}
          <li style={{ padding: "0 20px" }}>
            <Link
              to={process.env.PUBLIC_URL + "/shop-grid-standard?REFURBISHED"}
              onClick={() => handleClearFilters()}
              style={{ color: "#fff", lineHeight: "0px" }}
            >
              {" "}
              {t("REFURBISHED PHONES")}
            </Link>
          </li>
          <li style={{ padding: "0 20px" }}>
            <Link
              to={process.env.PUBLIC_URL + "/shop-grid-standard?NEW"}
              onClick={() => handleClearFilters()}
              style={{ color: "#fff", lineHeight: "0px" }}
            >
              {" "}
              {t("NEW PHONES")}
            </Link>
          </li>
          <li style={{ padding: "0 20px" }}>
            <Link
              to={`${process.env.PUBLIC_URL}/shop-grid-standard?USED`}
              onClick={() => handleClearFilters()}
              style={{ color: "#fff", lineHeight: "0px" }}
            >
              {t("PRE - OWNED")}
            </Link>
          </li>

          <li style={{ padding: "0 20px" }}>
            <Link
              to={process.env.PUBLIC_URL + "/branch"}
              style={{ color: "#fff", lineHeight: "0px" }}
            >
              {" "}
              {t("STORE LOCATIONS")}
            </Link>
          </li>
          <li style={{ padding: "0 20px" }}>
            <Link
              to={process.env.PUBLIC_URL + "/about"}
              style={{ color: "#fff", lineHeight: "0px" }}
            >
              {t("ABOUT US")}
            </Link>
          </li>
          <li style={{ padding: "0 20px" }}>

            <select
              value={selected}
              onChange={handleChange}
              style={{
                height: "30px",
                width: "100%",
                backgroundColor: "#1C4598",
                borderRadius: "5px",
                boxShadow: "0 0px 5px 0 rgba(0, 0, 0, 0.2)",
                color: "white",
                fontWeight: "500",
                letterSpacing: "1px"
              }}
            >
              <option value="" style={{ backgroundColor: "#1C4598" }}>MORE </option>
              <option value="/faq" style={{ backgroundColor: "#1C4598" }}>FAQ</option>
              {/* <option value="/blog" style={{ backgroundColor: "#1C4598" }}>BLOG</option> */}
              {/* <option value="/career" style={{ backgroundColor: "#1C4598" }}>CAREER</option> */}
              <option value="/policy" style={{ backgroundColor: "#1C4598" }}>POLICY</option>
              <option value="/t&c" style={{ backgroundColor: "#1C4598" }}>T & C</option>
              <option value="/contact" style={{ backgroundColor: "#1C4598" }}>CONTACT US</option>
            </select>
          </li>


        </ul>
      </nav>

      <div
        className="navopsan"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          backgroundColor: "#1a1a1a",
          position: "absolute",
          width: "auto",
          zIndex: "9999",
          display: "flex",
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          opacity: isHovering ? 1 : 0,
          transform: isHovering ? "translateY(0)" : "translateY(-10px)",
          pointerEvents: isHovering ? "auto" : "none",
          right: "80px",
          left: "80px",
          borderRadius: "20px",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          overflow: "hidden",
          height: "400px",
          maxHeight: "600px",
          border: "1px solid black"
        }}
      >
        {/* Categories Section */}
        <div
          style={{
            width: "35%",
            padding: "32px 28px",
            background: "white",
            position: "relative",
            color: "black",
            borderRight: "1px solid gray"
          }}
        >
          {/* Decorative background pattern */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 1px, transparent 1px),
            radial-gradient(circle at 80% 50%, rgba(255,255,255,0.1) 1px, transparent 1px)`,
              backgroundSize: "40px 40px",
              opacity: 0.3,
            }}
          />

          <div style={{ position: "relative", zIndex: 1 }}>
            <h3
              style={{
                color: "black",
                fontSize: "18px",
                fontWeight: "700",
                marginBottom: "24px",
                fontFamily: "'Inter', -apple-system, sans-serif",
                letterSpacing: "-0.025em",
              }}
            >
              Categories
            </h3>

            {[
              { label: "Top Brands", value: "TOP_BRANDS", icon: "⭐" },
              { label: "New Arrivals", value: "NEW_ARRIVALS", icon: "✨" },
              { label: "Best Sellers", value: "BEST_SELLERS", icon: "🔥" },
              { label: "Refurbished Phones", value: "REFURBISHED", icon: "♻️" },
            ].map(({ label, value, icon }) => (
              <div
                key={value}

                onClick={() => handleRedirect(value)}
                onMouseOver={() => handleMouseenter(value)}
                style={{
                  cursor: "pointer",
                  padding: "16px 20px",
                  marginBottom: "8px",
                  borderRadius: "12px",
                  color: "black",
                  fontFamily: "'Inter', -apple-system, sans-serif",
                  fontSize: "15px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  border: "1px solid gray",
                  transition: "background 0.2s",
                }}
              >
                <span style={{ fontSize: "18px" }}>{icon}</span>
                {label}
              </div>
            ))}
          </div>
        </div>

        {/* Brands Section */}
        {renderBrandDiv(brands)}

        {/* Product Image Section */}
        <div
          style={{
            width: "30%",
            padding: "10px 10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #2d3748 0%, #1a202c 100%)",
            position: "relative",
          }}
        >

          <div
            style={{
              position: "relative",
              height: "100%",
              width: "100%",
              padding: "20px",
              borderRadius: "20px",
              background: "rgba(255, 255, 255, 0.05)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
            }}
          >
            <img
              src={categoryImages[hoveredCategory]}
              alt="Category Visual"
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "100%",
                filter: "drop-shadow(0 10px 25px rgba(0, 0, 0, 0.3))",
                opacity: imageOpacity,
                transition: "opacity 0.3s ease-in-out",
              }}
            />
          </div>
        </div>
      </div>
    </div >
  );
};

NavMenuNew.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
};

export default NavMenuNew;
